export default function (to, from, next) {
  document.title = to.meta.title || globalUrls.title || "Pixellot";

  next();
}
